import type { Notification } from "~types/notification";
import BasePopoverNotificationItem from "./BasePopoverNotificationItem";

type Props = {
  notification: Notification;
  onClick: (notification: Notification) => void;
};

const DefaultPopoverNotificationItem = ({ notification, onClick }: Props) => {
  return <BasePopoverNotificationItem notification={notification} onClick={onClick} icon="fa-circle-exclamation" />;
};

export default DefaultPopoverNotificationItem;
